export const FREESTAR_PUBLISHER = "u-gg";

export enum FreestarPlacements {
  IabFoot1 = "u-gg_iab_foot1",
  LeaderboardATF = "u-gg_leaderboard_atf",
  MedRectATF = "u-gg_med_rect_atf",
  MedRectBTF = "u-gg_med_rect_btf",
  MedRectBTF2 = "u-gg_med_rect_btf2",
  OopFlex = "u-gg_oop-flex",
  LeftRail = "u-gg_left_rail",
  RightRail = "u-gg_right_rail",
  BottomRail = "u-gg_bottom_rail",
  Video = "FreeStarVideoAdContainer_Slider",
}
